export default __webpack_public_path__ + "static/media/chartOn.0741fe90.svg";